import { render } from "./appExamPaper.vue?vue&type=template&id=ee05cd64&scoped=true"
import script from "./appExamPaper.vue?vue&type=script&lang=js"
export * from "./appExamPaper.vue?vue&type=script&lang=js"

import "./appExamPaper.vue?vue&type=style&index=0&id=ee05cd64&lang=less&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee05cd64"]])

export default __exports__